import React, { useEffect, useState } from 'react';
import AdminCompOffSc from './Admin.sc';
import { get_all_employee_compoff } from '../../api/Compoff/get_all_employee_compoff';
import { useAuthContext } from '../../hooks';
import ModalComp from "./ApproveModal/Modal"
const AdminCompoff = () => {
  const auth = useAuthContext();
  const [compOff, setCompOff] = useState<any>([]);

  const fetchCompOff = async () => {
    const res = await get_all_employee_compoff(auth?.userInfo?.orgs[0]?.id);
    setCompOff(res);
  };

  useEffect(() => {
    fetchCompOff();
  }, []);

  const [sortedData, setSortedData] = useState([]);
  useEffect(() => {
    const sorted:any = [...compOff].sort((a, b) => new Date(b.e_applied_on).getTime() - new Date(a.e_applied_on).getTime());
    setSortedData(sorted);
  }, [compOff]);
  const formatDate = (dateString:string) => {
    const date = new Date(dateString);
    return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`;
  };
  return (
    <AdminCompOffSc>
      <div>AdminCompoff</div>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Reason</th>
            <th>Reporting Manager</th>
            <th>Country Manager</th>
            <th>Applied On</th>
            <th>Take action</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item:any, index:any) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.reason}</td>
              <td>{item.status}</td>
              <td>{item?.e_pto_approved_c_manager=== 0 ||item?.e_pto_approved_c_manager ==='0' ? "Declined":item?.e_pto_approved_c_manager===1||item?.e_pto_approved_c_manager ==='1' ? "Approved":"No response"}</td>
              <td>{formatDate(item.e_applied_on)}</td>
              <td>

              <ModalComp data={item} fetchUser ={fetchCompOff} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminCompOffSc>
  );
};

export default AdminCompoff;
